import React from 'react';
import { Modal, Box, Typography, Button, Stack } from '@mui/material';
import { useLanguageContext } from '../../hooks/useContext/useLanguageContext';
import LanguageIcon from '@mui/icons-material/Language';

const LanguageSelector = () => {
  const { showLanguageSelector, setLanguage } = useLanguageContext();

  const handleLanguageSelect = (lang) => {
    setLanguage(lang);
  };

  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: 450 },
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    textAlign: 'center',
  };

  const buttonStyle = {
    minHeight: '60px',
    fontSize: '1.1rem',
    fontWeight: 'bold',
    textTransform: 'none',
  };

  return (
    <Modal
      open={showLanguageSelector}
      aria-labelledby="language-selector-modal"
      aria-describedby="select-your-preferred-language"
      disableEscapeKeyDown
      BackdropProps={{
        style: {
          backgroundColor: 'rgba(0, 0, 0, 0.8)',
        },
      }}
    >
      <Box sx={modalStyle}>
        <LanguageIcon sx={{ fontSize: 60, color: 'primary.main', mb: 2 }} />
        
        <Typography id="language-selector-modal" variant="h4" component="h2" gutterBottom>
          Welcome / Witamy
        </Typography>
        
        <Typography variant="body1" sx={{ mb: 4, color: 'text.secondary' }}>
          Please select your preferred language<br />
          Proszę wybrać preferowany język
        </Typography>

        <Stack spacing={2}>
          <Button
            variant="contained"
            onClick={() => handleLanguageSelect('en')}
            sx={buttonStyle}
            fullWidth
          >
            🇬🇧 English
          </Button>
          
          <Button
            variant="contained"
            onClick={() => handleLanguageSelect('pl')}
            sx={buttonStyle}
            fullWidth
          >
            🇵🇱 Polski
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default LanguageSelector;
